export enum VEHICLE_REGULATION_MODES {
  REGULATED = 'regulated',
  UNREGULATED = 'unregulated',
}
